import React from "react";
import UDigLogo from "../images/UDig-white-logo.png";
import { Link } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import { Button } from "@mui/base";

const activeStyle =
  "flex bg-white text-UDig-gray text-left font-sans font-bold px-4 py-2";
const inactiveStyle =
  "flex bg-UDig-navy text-white text-left font-sans font-bold px-4 py-2";

const summaryActiveStyle =
  "flex bg-white text-UDig-orange text-left font-sans font-bold px-4 py-2";
const summaryInactiveStyle =
  "flex bg-UDig-orange text-white text-left font-sans font-bold px-4 py-2";

interface NavBarProps {
  activePage: string;
  className?: string;
  completed: boolean;
}

const NavBar: React.FC<NavBarProps> = ({ activePage, completed }) => {
  const { user } = useUser();

  const handleShare = () => {
    const url = `https://businesscase.udig.com/${activePage}/${user.uuid}`;

    navigator.clipboard
      .writeText(url)
      .then(() => {
        alert("Text copied to clipboard:" + url);
        console.log("Text copied to clipboard:", url);
      })
      .catch((err) => {
        alert("Text copied to clipboard:" + url);
        console.error("Failed to copy text:", err);
      });
  };

  return completed ? (
    <div className="h-screen w-72 bg-UDig-gray fixed flex flex-col exclude-element">
      {/* UDig logo on the top left links to udig.com */}
      <a href="https://www.udig.com/">
        <div className="h-24 w-full bg-UDig-navy flex items-end">
          <img className="w-24 ml-4 m-2" src={UDigLogo} alt="UDig logo" />
        </div>
      </a>
      <Link to={`/Instructions/${user.uuid}`}>
        <div
          className={`${
            activePage === "Instructions" ? activeStyle : inactiveStyle
          }`}
        >
          Instructions
        </div>
      </Link>

      <Link to={`/Objective/${user.uuid}`}>
        <div
          className={`${
            activePage === "Objective" ? activeStyle : inactiveStyle
          }`}
        >
          Objective
        </div>
      </Link>

      <Link to={`/Costs/${user.uuid}`}>
        <div
          className={`${activePage === "Costs" ? activeStyle : inactiveStyle}`}
        >
          Costs
        </div>
      </Link>

      <Link to={`/Quantitative/${user.uuid}`}>
        <div
          className={`${
            activePage === "Quantitative" ? activeStyle : inactiveStyle
          }`}
        >
          Quantitative Financial Benefits
        </div>
      </Link>

      <Link to={`/Qualitative/${user.uuid}`}>
        <div
          className={`${
            activePage === "Qualitative" ? activeStyle : inactiveStyle
          }`}
        >
          Qualitative Benefits
        </div>
      </Link>

      <Link to={`/Assumptions/${user.uuid}`}>
        <div
          className={`${
            activePage === "Assumptions" ? activeStyle : inactiveStyle
          }`}
        >
          Assumptions
        </div>
      </Link>

      <Link to={`/Review/${user.uuid}`}>
        <div
          className={`${activePage === "Review" ? activeStyle : inactiveStyle}`}
        >
          Review
        </div>
      </Link>

      <div
        className={`${
          activePage === "Summary" ? summaryActiveStyle : summaryInactiveStyle
        }`}
      >
        Summary
      </div>
      <Button
        className="mt-auto mx-4 mb-4 text-white bg-UDig-orange p-2 rounded-md"
        onClick={() => handleShare()}
      >
        Share URL
      </Button>
    </div>
  ) : (
    <div className="h-screen w-72 bg-UDig-gray fixed flex flex-col exclude-element">
      <a href="https://www.udig.com/">
        <div className="h-24 w-full bg-UDig-navy flex items-end">
          <img className="w-24 ml-4 m-2" src={UDigLogo} alt="UDig logo" />
        </div>
      </a>

      <div
        className={`${
          activePage === "Instructions" ? activeStyle : inactiveStyle
        }`}
      >
        Instructions
      </div>

      <div
        className={`${
          activePage === "Objective" ? activeStyle : inactiveStyle
        }`}
      >
        Objective
      </div>

      <div
        className={`${activePage === "Costs" ? activeStyle : inactiveStyle}`}
      >
        Costs
      </div>

      <div
        className={`${
          activePage === "Quantitative" ? activeStyle : inactiveStyle
        }`}
      >
        Quantitative Financial Benefits
      </div>

      <div
        className={`${
          activePage === "Qualitative" ? activeStyle : inactiveStyle
        }`}
      >
        Qualitative Benefits
      </div>

      <div
        className={`${
          activePage === "Assumptions" ? activeStyle : inactiveStyle
        }`}
      >
        Assumptions
      </div>

      <div
        className={`${activePage === "Review" ? activeStyle : inactiveStyle}`}
      >
        Review
      </div>

      <div
        className={`${
          activePage === "Summary" ? summaryActiveStyle : summaryInactiveStyle
        }`}
      >
        Summary
      </div>
      <Button
        className="w-1/2 mt-auto mx-4 mb-4 font-bold text-white bg-UDig-orange p-2 rounded-md"
        onClick={() => handleShare()}
      >
        Share URL
      </Button>
    </div>
  );
};

export default NavBar;
